import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import { useNavigate } from 'react-router-dom';

function Index() {
  const navigate = useNavigate();
  const { fulluser } = useContext(AuthContext);
  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 1000); // fallback after 3 seconds

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const isVerified = sessionStorage.getItem("mpin_verified") === "true";
    const hasMPIN = localStorage.getItem("mpin");

    if (fulluser?.id) {
      navigate("/Main");
    } else if (timeoutReached) {
      // fulluser is still not set after timeout: go to Main
      navigate("/Main");
    }
  }, [fulluser, timeoutReached, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
      <div className="text-center">
        <img
          src="app_logo.png"
          alt="Loading..."
          style={{ width: "170px", height: "170px" }}
        />
        <div className="mt-2">Loading...</div>
      </div>
    </div>
  );
}

export default Index;
